// This module is deliberately renderer-free: the player owns local persistence.
export const preferenceKey = (server, user) => `skyview.scene.v1:${encodeURIComponent(server)}:${encodeURIComponent(user || 'local')}`;
const object = value => value !== null && typeof value === 'object' && !Array.isArray(value);
export function readPreferences(raw) {
  try {
    const value = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (!object(value) || value.version !== 1) return {version: 1};
    const result = {version: 1};
    for (const key of ['map', 'defaultModel', 'sources', 'platforms']) {
      if (object(value[key])) result[key] = value[key];
    }
    if (typeof value.panelCollapsed === 'boolean') result.panelCollapsed = value.panelCollapsed;
    return result;
  } catch { return {version: 1}; }
}
